export enum LoginViews {
    DEFAULT = "default",
    OAUTH = "oauth",
}